// Foldable Food Menu — Naljuri Inn (with BBQ extension)
export const MENU = {
  tagline_en: "Perfect dining, hill-side.",
  tagline_bn: "পাহাড়ের কোলে, পরিপূর্ণ ভোজন।",
  sections: [
    {
      key: "breakfast", name_en: "Breakfast", name_bn: "নাস্তা", time: "07:30 — 10:30",
      hero_img: "https://images.unsplash.com/photo-1525351484163-7529414344d8?w=1400&q=85&auto=format&fit=crop",
      caption_en: "Hand-rolled paratha, vorta, tea on the porch.",
      caption_bn: "হাতে গড়া পরোটা, ভর্তা, বারান্দায় চা।",
      items: [
        { name_en: "Regular", name_bn: "নিয়মিত", price_bdt: 100,
          desc_en: "Special paratha · Vegetable curry · Egg fry · A cup of tea",
          desc_bn: "স্পেশাল পরোটা · সবজি কারি · ডিম ভাজি · এক কাপ চা" },
        { name_en: "Spicy", name_bn: "ঝাল", price_bdt: 100,
          desc_en: "Khichuri · Vorta · Egg fry · A cup of tea",
          desc_bn: "খিচুড়ি · ভর্তা · ডিম ভাজি · এক কাপ চা" },
        { name_en: "English", name_bn: "ইংলিশ", price_bdt: 100,
          desc_en: "Bread / toast · Jelly · Egg fry · A cup of tea",
          desc_bn: "ব্রেড / টোস্ট · জেলি · ডিম ভাজি · এক কাপ চা" },
      ],
    },
    {
      key: "lunch", name_en: "Lunch", name_bn: "দুপুরের খাবার", time: "12:30 — 15:30",
      hero_img: "https://images.unsplash.com/photo-1574484284002-952d92456975?w=1400&q=85&auto=format&fit=crop",
      caption_en: "Slow-cooked curries, unlimited rice.",
      caption_bn: "ধীরে রান্না করা তরকারি, আনলিমিটেড ভাত।",
      items: [
        { name_en: "Regular", name_bn: "নিয়মিত", price_bdt: 100,
          desc_en: "Rice · Vorta · Vegetable · Dal",
          desc_bn: "ভাত · ভর্তা · সবজি · ডাল" },
        { name_en: "Special", name_bn: "স্পেশাল", price_bdt: null,
          desc_en: "Roasted Duck — 300 · Desi Chicken — 350 · Beef Curry — 250 · Unlimited rice & dal",
          desc_bn: "রোস্টেড হাঁস — ৩০০ · দেশি মুরগী — ৩৫০ · গরুর মাংস — ২৫০ · আনলিমিটেড ভাত ও ডাল" },
      ],
    },
    {
      key: "dinner", name_en: "Dinner", name_bn: "রাতের খাবার", time: "19:30 — 22:30",
      hero_img: "https://images.unsplash.com/photo-1604908176997-125f25cc6f3d?w=1400&q=85&auto=format&fit=crop",
      caption_en: "Roasted duck, desi chicken, by candlelight.",
      caption_bn: "মোমবাতির আলোয় রোস্টেড হাঁস, দেশি মুরগী।",
      items: [
        { name_en: "Regular", name_bn: "নিয়মিত", price_bdt: 100,
          desc_en: "Rice · Vorta · Vegetable · Dal",
          desc_bn: "ভাত · ভর্তা · সবজি · ডাল" },
        { name_en: "Special", name_bn: "স্পেশাল", price_bdt: null,
          desc_en: "Roasted Duck — 300 · Desi Chicken — 350 · Beef Curry — 250 · Unlimited rice & dal",
          desc_bn: "রোস্টেড হাঁস — ৩০০ · দেশি মুরগী — ৩৫০ · গরুর মাংস — ২৫০ · আনলিমিটেড ভাত ও ডাল" },
      ],
    },
    {
      key: "bbq", name_en: "BBQ Night", name_bn: "বার-বি-কিউ নাইট", time: "20:00 — 23:00",
      hero_img: "https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=1400&q=85&auto=format&fit=crop",
      caption_en: "Charcoal-grilled, hill-side, under the stars.",
      caption_bn: "তারার নিচে, পাহাড়ের কোলে, কাঠকয়লায় ঝলসানো।",
      featured: true,
      items: [
        { name_en: "Chicken Tikka Skewer", name_bn: "চিকেন টিক্কা স্কিউয়ার", price_bdt: 250,
          desc_en: "Marinated 12 hrs · charcoal-grilled · mint chutney",
          desc_bn: "১২ ঘণ্টা ম্যারিনেট · কাঠকয়লায় গ্রিল · পুদিনা চাটনি" },
        { name_en: "Beef Seekh Kebab", name_bn: "বিফ সিক কাবাব", price_bdt: 300,
          desc_en: "Hand-minced beef · charred peppers · raw onion",
          desc_bn: "হাতে কিমা করা গরুর মাংস · ঝলসানো মরিচ · পেঁয়াজ" },
        { name_en: "Lamb Chops", name_bn: "ল্যাম্ব চপ্স", price_bdt: 450,
          desc_en: "Sylheti spices · slow-grilled · pomegranate glaze",
          desc_bn: "সিলেটি মশলা · ধীরে গ্রিল · ডালিমের গ্লেজ" },
        { name_en: "Fish Tikka (Rui)", name_bn: "ফিশ টিক্কা (রুই)", price_bdt: 280,
          desc_en: "River rui · yogurt-mustard marinade · lemon",
          desc_bn: "নদীর রুই · দই-সরিষা ম্যারিনেড · লেবু" },
        { name_en: "Grilled Vegetable Platter", name_bn: "গ্রিলড ভেজি প্লেটার", price_bdt: 200,
          desc_en: "Capsicum · cauliflower · paneer · corn · aubergine",
          desc_bn: "ক্যাপসিকাম · ফুলকপি · পনির · ভুট্টা · বেগুন" },
        { name_en: "Whole Tandoori Chicken", name_bn: "হোল তন্দুরি চিকেন", price_bdt: 800,
          desc_en: "Pre-order 4 hrs · serves 3-4 · butter naan included",
          desc_bn: "৪ ঘণ্টা আগে অর্ডার · ৩-৪ জনের জন্য · বাটার নান সহ" },
      ],
    },
  ],
};

// Nearby destinations — owner-supplied hub of 10 marquee places around the property
export const NEARBY = [
  { en: "Sadapathor", bn: "সাদাপাথর", note_en: "Crystal-clear marble basin", note_bn: "স্বচ্ছ মার্বেল অববাহিকা" },
  { en: "Jaflong",    bn: "জাফলং",    note_en: "Stone-gathering culture",   note_bn: "পাথর-সংগ্রহের সংস্কৃতি" },
  { en: "Lalakhal",   bn: "লালাখাল",   note_en: "Turquoise river at sunset", note_bn: "সূর্যাস্তে টারকোয়েজ নদী" },
  { en: "Bisnakandi", bn: "বিছনাকান্দি", note_en: "Three streams, one valley", note_bn: "তিন ঝর্ণা, এক উপত্যকা" },
  { en: "Pangthumai", bn: "পাংথুমাই", note_en: "Bangladesh's hidden waterfall", note_bn: "বাংলাদেশের লুকানো ঝর্ণা" },
  { en: "Ratargul",   bn: "রাতারগুল", note_en: "Freshwater swamp forest", note_bn: "মিঠা পানির জলাবন" },
  { en: "Tea Gardens", bn: "চা বাগান", note_en: "Lakkatura, Malnicherra", note_bn: "লাক্কাতুরা, মালনিছড়া" },
  { en: "Dibir Haor", bn: "ডিবির হাওর", note_en: "Red water-lily basin",     note_bn: "লাল শাপলার বিল" },
  { en: "Naljuri Jharna", bn: "নলজুরি ঝরনা", note_en: "Our private monsoon waterfall", note_bn: "আমাদের নিজস্ব বর্ষার ঝরনা" },
  { en: "Naljuri Cricket Field", bn: "নলজুরি ক্রিকেট মাঠ", note_en: "\"Banglar Pahalgam\" — viral", note_bn: "\"বাংলার পেহেলগাম\" — ভাইরাল" },
];
